<ion-content color="gray" forceOverscroll="false" class="content">
  <!-- Nombre del usuario -->
  <ion-card mode="md" color="tpcta" class="animated fadeIn fast card-name">
    <ion-item mode="md" color="tpcta" lines="nones" class="ion-text-center">
      <ion-label mode="md" color="white">
        {{ responsable }}
        <p>
          {{ 'Labels.think-also-interested' | translate }}
        </p>
      </ion-label>
    </ion-item>
  </ion-card>

  <!-- Listado de los productos -->
  <ng-container
    *ngFor="
    let product of products
  "
  >
    <app-product-card
      [product]="product"
      [claveProducto]="product.clave_producto"
      [cardProductFilter]="
          (referenceProducts | filterArray: product.clave_producto:'clave_producto')[0]
      "
      (addProducto)="addProducto($event)"
    ></app-product-card>
  </ng-container>
</ion-content>

<ion-footer mode="md">
  <!-- Total Carrito -->
  <ion-toolbar mode="md" color="grayContrast" class="ion-text-center">
    <ion-item mode="md" color="grayContrast" lines="nones" class="item-total">
      <ion-label mode="md" color="status-icon-enable" class="total-boxes">
        {{ 'Labels.my-order' | translate }}
      </ion-label>

      <ion-label
        mode="md"
        color="darkblue"
        class="ion-float-right ion-text-end"
      >
        <p class="mpe-font-weight-600 total-price">
          {{ totalPrice | currency }}
        </p>
        <ion-text mode="md" color="status-icon-enable" class="total-price">
          {{ productsCart | sumTotal: 'productos' }} {{ 'Labels.boxes' |
          translate | lowercase }}
        </ion-text>
      </ion-label>
    </ion-item>
  </ion-toolbar>

  <!-- Boton de omitir o Confirmar -->
  <ion-toolbar mode="md" color="mediumRgba" class="ion-text-center">
    <ion-button
      size="default"
      mode="ios"
      color="tpcta"
      [disabled]="totalPrice < 1"
      class="button-add-cart"
      (click)="onButton()"
    >
      <ion-label mode="md">
        <ng-container *ngIf="!isChange">
          {{ 'Buttons.not-for-now' | translate }}
        </ng-container>

        <ng-container *ngIf="isChange">
          {{ 'Buttons.update-order' | translate }}
        </ng-container>
      </ion-label>
    </ion-button>
  </ion-toolbar>
</ion-footer>
